module.exports = __webpack_public_path__ + "static/img/uu.ee9d246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/uu.png
// module id = jRNy
// module chunks = 8